import * as React from 'react'

import { Card } from '@procurify/ui'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import messages from './messages'

const UnitTypeManagementViewChunk = React.lazy(() =>
  import('@webapp/modules/purchasing/feature-sets/UnitTypeManagementView').then(
    ({ UnitTypeManagementView }) => ({
      default: UnitTypeManagementView,
    })
  )
)

export const CustomizeUnitTypesPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.customizeUnitTypesTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.customizeUnitTypesTitle),
        },
      ]}
    >
      <Card>
        <Card.Content>
          <UnitTypeManagementViewChunk />
        </Card.Content>
      </Card>
    </Page>
  )
}
